module.exports = __webpack_public_path__ + "img/logo-vtex.af219bb0.svg";